// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6j45l","icon":"Footer_icon__Eyxhf","text":"Footer_text__EM4as","link":"Footer_link__unfuD"};